import { Route } from '@angular/router';
import { RelatedToType } from '@shared/enums';

export namespace AssetManagementRouting {
  export const routeToObjectMap = {
    // that's currently misleading because the leases route
    // is mapped to an object called PropertyTenant and not Lease
    leases: RelatedToType.PropertyTenant,
    properties: RelatedToType.Property,
  };

  export const assetManagement = 'asset-management';
  export const generalLedger = 'general-ledger';
  export const trialBalance = 'trial-balance';
  export const balanceSheet = 'balance-sheet';
  export const incomeStatement = 'income-statement';
  export const budget = 'budget';
  export const trailingIncomeStatement = 'trailing-income-statement';

  export const routes: Route[] = [
    {
      path: AssetManagementRouting.generalLedger,
      loadComponent: () =>
        import('./containers/general-ledger-container/general-ledger-container.component').then(
          (m) => m.GeneralLedgerContainerComponent,
        ),
      title: () => 'General Ledger',
    },
    {
      path: AssetManagementRouting.trialBalance,
      loadComponent: () =>
        import('./containers/trial-balance-container/trial-balance-container.component').then(
          (m) => m.TrialBalanceContainerComponent,
        ),
      title: () => 'Trial Balance',
    },
    {
      path: AssetManagementRouting.balanceSheet,
      loadComponent: () =>
        import('./containers/balance-sheet-container/balance-sheet-container.component').then(
          (m) => m.BalanceSheetContainerComponent,
        ),
      title: () => 'Balance Sheet',
    },
    {
      path: AssetManagementRouting.incomeStatement,
      loadComponent: () =>
        import('./containers/income-statement-container/income-statement-container.component').then(
          (m) => m.IncomeStatementContainerComponent,
        ),
      title: () => 'Income Statement',
    },
    {
      path: AssetManagementRouting.budget,
      loadComponent: () =>
        import('./containers/budget-container/budget-container.component').then((m) => m.BudgetContainerComponent),
      title: () => 'Budget',
    },
    {
      path: AssetManagementRouting.trailingIncomeStatement,
      loadComponent: () =>
        import('./containers/trailing-income-statement-container/trailing-income-statement-container.component').then(
          (m) => m.TrailingIncomeStatementContainerComponent,
        ),
      title: () => 'Trailing Income Statement',
    },
  ];
}
